import React, { Component } from 'react';
import TSelect from '../../common/TSelect';
import TButton from '../../common/TButton';
import TInputForm from "../../common/TInputForm";
import { connect } from 'react-redux';
import { receiveWaitingMembers } from '../../../actions/setting/teamblog'
import TTextareaForm from "../../common/TTextareaForm";
import * as RoleType from "../../../constants/user/RoleType";
import * as InvitationButtonStatusLabel from '../../../constants/InvitationButtonStatusLabel'
import { jsonResponseHandler } from '../../../utils/FetchHelper'
import {addPrefix} from "../../../utils/UriUtil";

@connect(state => ({
    currentUserRole : state.user.role,
    userName : state.user.name,
    blogTitle : state.blog.title,
    blogDomain : state.blog.domain,
}), (dispatch) => ({
    handleReceiveWaitingMembers: (items) => {
        dispatch(receiveWaitingMembers(items))
    },
    dispatch
}))
class TeamBlogInvitation extends Component {

    constructor(props) {
        super(props);

        const defaultValue = {
            email : '',
            role : 'writer',
            content : '',
        };

        this.state = {
            initialValue : defaultValue,
            inputValue : defaultValue,
            openLayer : false,
            message : '',
            tempEmailInput: ''
        };

        this.toggleInputLayer = this.toggleInputLayer.bind(this);
        this.changeSelection = this.changeSelection.bind(this);
        this.handleInvite = this.handleInvite.bind(this);
        this.handleEmailInput = this.handleEmailInput.bind(this);
        this.handleContentInput = this.handleContentInput.bind(this);
        this.inputValidation = this.inputValidation.bind(this);
        this.makeDefaultInviteMessage = this.makeDefaultInviteMessage.bind(this);
    }

    makeDefaultInviteMessage() {
		const { userName, blogTitle, blogDomain } = this.props;

        return `${userName}님이 팀블로그로 초대하였습니다.\n- 블로그명: ${blogTitle}\n- 블로그 주소: ${blogDomain}`;
    }

    toggleInputLayer() {
        this.setState({
            openLayer : !this.state.openLayer
        })
    }

    handleEmailInput(value) {

        const { inputValue } = this.state;
        const emailValidationRegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        this.setState({
            tempEmailInput : value
        });

        if(emailValidationRegExp.test(value)){
            this.setState({
                inputValue : Object.assign({}, inputValue, {
                    email : value,

                }),
                message : '',
            })
        }else{
            this.setState({
                inputValue : Object.assign({}, inputValue, {
                    email : '',

                }),
                message : '',
            })
        }
    }

    handleContentInput(content) {

        const { inputValue } = this.state;

        this.setState({
            inputValue : Object.assign({}, inputValue, {
                content : content
            }),
            message : '',
        })
    }

    changeSelection(property, value) {
        const { inputValue }= this.state;
        let diff = {};
        diff[property] = value;

        this.setState({
            inputValue : Object.assign({}, inputValue, diff),
            message : '',
        });
    }

    inputValidation() {
        const { inputValue } = this.state;

        if(inputValue.email === ''){
            this.setState({
                message: '올바른 이메일을 입력해주십시오',
            });
            return false;
        }
        return true;
    }

    handleInvite(callback, failCallback){

        const { dispatch } = this.props;
        const { inputValue } = this.state;

        const body = {
            email : inputValue.email,
            role : inputValue.role,
            content : (inputValue.content.trim()==='')? this.makeDefaultInviteMessage():inputValue.content,
        };

        fetch(addPrefix("/manage/teamblog/sendInvite.json"),
            {
                method: 'post',
                credentials: 'include',
                headers: {'Content-Type':'application/json'},
                body: JSON.stringify(body)
            })
            .then(jsonResponseHandler(dispatch))
            .then(r => r.json())
            .then(data => {

                if(data.success) {
                    this.setState({
                        inputValue : {
                            email : '',
                            role : this.state.inputValue.role,
                            content : this.state.inputValue.content,
                        },
                        tempEmailInput: '',
                        message : data.message
                    });
                    this.props.handleReceiveWaitingMembers(data.waitingMembers);
                }else{
                    this.setState({
                        message : data.message
                    });
                }
                callback();
            })
            .catch(e => {
                console.log(e);
                failCallback();
            });
    }



    render() {

        const { openLayer, initialValue, inputValue, message, tempEmailInput } = this.state;
        const { currentUserRole } = this.props;
        const optionList = {
            role : [
                { name : 'manager' , label : '관리자', value : 'manager'},
                { name : 'editor' , label : '편집자', value : 'editor'},
                { name : 'writer' , label : '필자', value : 'writer'},
            ]
        };

        const invitationRequireRole = RoleType.MANAGER;

        if(openLayer) {
            return (
                <div className="wrap_set">
                    <div className="desc_invite">
                        <p className="txt_invite">티스토리 블로거를 초대해 함께 팀블로그를 운영하거나 팀원 정보를 관리할 수 있습니다.</p>
                        <button type="button" className="btn_post" onClick={this.toggleInputLayer}>닫기</button>
                    </div>
                    <form >
                        <div className="info_invite">
                            <label className="lab_tf">
                                <strong className="tit_set">받는 사람</strong>
                                <TInputForm type="text" className={'tf_blog'} placeholder="이메일 주소를 입력해주세요." value={tempEmailInput} onChange={(e) => this.handleEmailInput(e)}/>
                            </label>
                            <div className="lab_tf lab_invite">
                                <strong className="tit_set">초대말</strong>
                                <TTextareaForm className="tf_blog" defaultValue={this.makeDefaultInviteMessage()} onChange={this.handleContentInput} />
                            </div>
                            <div className="item_set">
                                <TSelect defaultClassName={'opt_set opt_manage1'} selectItem={this.changeSelection} propertyName={"role"} selected={inputValue} optionList={optionList} />
                                권한으로 초대합니다.
                                <a href="http://notice.tistory.com/1785" className="info_sub" target="_blank">자세히 보기</a>
                            </div>
                        </div>
                        { RoleType.canAccess(RoleType.convertStringToRoleType(currentUserRole),invitationRequireRole) &&
                        <fieldset>
                            <legend className="screen_out">초대 버튼</legend>
                            <p className="txt_required">{message}</p>
                            <TButton onClick={this.handleInvite} checkValidation={this.inputValidation} initialValues={initialValue.email} currentValues={inputValue.email} label={InvitationButtonStatusLabel} />
                        </fieldset>}
                    </form>
                </div>
            );
        }

        return (
            <div className="wrap_set">
                <div className="desc_invite">
                    <p className="txt_invite">티스토리 블로거를 초대해 함께 팀블로그를 운영하거나 팀원 정보를 관리할 수 있습니다.</p>
                    { RoleType.canAccess(RoleType.convertStringToRoleType(currentUserRole),invitationRequireRole) &&
                    <button type="button" className="btn_post" onClick={this.toggleInputLayer}>초대하기</button>
                    }
                </div>
            </div>
        );
    }
}

export default TeamBlogInvitation;
